// extracted by mini-css-extract-plugin
module.exports = {"submenu":"styles__submenu--1HsnA","submenuTextLink":"styles__submenuTextLink--2gGUG","submenuFeaturedLink":"styles__submenuFeaturedLink--2ZWuQ"};
    if(module.hot) {
      // 1541451128458
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  